import React, { useState } from "react";
import { enumAvailableLanguages } from "./models/SettingsEnums";
import { useOnChangeWatcher } from "./models/useOnChangeWatcher";
import { Globe } from "lucide-react";
import { itx } from "./translationItx/itx";

export default function LanguagePickerWithIcon(props: { style?: any; className?: any; iconOnly?: boolean }) {
  const { style, className, iconOnly = false } = props;
  const [showDropdown, setShowDropdown] = useState(false);

  useOnChangeWatcher(state.settings);
  const language = state.settings.uiLanguage;

  const availableLanguages = [enumAvailableLanguages.german, enumAvailableLanguages.english];
  const handleLanguageChange = (language: enumAvailableLanguages | undefined) => {
    if (language && language != state.settings.uiLanguage) {
      void state.settings.setUiLanguage(language);
    }
  };

  function getLabelForLanguage(language: any) {
    switch (language) {
      case enumAvailableLanguages.german:
        return "Deutsch"; // no itx

      case enumAvailableLanguages.italian:
        return "Italiano"; // no itx

      case enumAvailableLanguages.english:
      default:
        return "English"; // no itx // No need to translate language labels
    }
  }
  function getLanguageShort(language: enumAvailableLanguages): string {
    return language.substring(0, 2).toUpperCase();
  }

  if (iconOnly) return <label className={className} style={style}>
    <Globe aria-hidden="true" />
    <select aria-label={itx("languagePicker.chooseLanguage", "Sprache auswählen")} value={language}
      onChange={event => handleLanguageChange(event.target.value as enumAvailableLanguages)}>
      {availableLanguages.map(value => <option key={value} value={value}>{getLabelForLanguage(value)}</option>)}
    </select>
  </label>;

  function DropdownItem(props: { language: enumAvailableLanguages }): any {
    const { language } = props;

    return (
      <div
        id={language}
        style={{
          backgroundColor: state.settings.uiLanguage == language ? "var(--dropdown-color)" : "transparent",
          color: state.settings.uiLanguage == language ? "white" : "black",
          padding: "2px 10px ",
          display: "block",
          borderRadius: "2px",
        }}
        onClick={() => {
          handleLanguageChange(language);
          setShowDropdown(false);
        }}
      >
        {getLabelForLanguage(language)}
      </div>
    );
  }
  const dropdownItems = new Array<any>();
  availableLanguages.forEach((language) => {
    dropdownItems.push(<DropdownItem key={language} language={language} />);
  });

  // // Close the dropdown menu if the user clicks outside of it
  // window.onclick = function(event) {
  //   if (!event.target.matches('.dropbtn')) {
  //     var dropdowns = document.getElementsByClassName("dropdown-content");
  //     var i;
  //     for (i = 0; i < dropdowns.length; i++) {
  //       var openDropdown = dropdowns[i];
  //     }
  //   }
  // }

  return (
    <div style={{ width: "max-content", height: "max-content" }} onBlur={() => {}}>
      <button
        className="buttonDropdownWithIcon"
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
        style={{
          backgroundColor: "transparent",
          border: `1px solid ${!showDropdown ? "var(--primary-color-light)" : "var(--bs-highlight-bg)"}`,
          borderRadius: "5px",
        }}
      >
        <i
          className="las la-language"
          style={{
            fontSize: "20px",
            color: "black",
          }}
        />
        {getLanguageShort(language)}
        <i
          className={showDropdown ? "las la-angle-down" : "las la-angle-up"} // no itx
          style={{
            fontSize: "10px",
            color: "black",
          }}
        />
      </button>
      <div
        id="LangaugeDropdown"
        className="dropdwonContent"
        style={{
          display: showDropdown ? "block" : "none",
          position: "absolute",
          backgroundColor: "white",
          width: "max-content",
          boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
          zIndex: "2",
          borderRadius: "2px",
        }}
        onBlur={() => {}}
      >
        {dropdownItems}
      </div>
    </div>
  );
}
